<div class="settings-navigation" data-test="settings-navigation">
  <nav mat-tab-nav-bar color="accent" [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
    <a mat-tab-link [routerLink]="['/third-parties', 'nedap']" [active]="isNedap$ | async">
      {{ 'settings.third-parties.nedap' | translate }}
    </a>
    <a mat-tab-link [routerLink]="['/third-parties', 'leeo']" [active]="isLeeO$ | async">
      {{ 'settings.third-parties.lee-o' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
